import React from 'react'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import AcademicServicesEle from './AcademicSerivceEle'


function Main() {
    return (
      <>
          <Header/>
          <Breadcrumb title="Home" subtitle="Academic Calendars"/>
        <AcademicServicesEle />
      </>
    )
  }
  
  export default Main